import { render, staticRenderFns } from "./CoreAdvantages.vue?vue&type=template&id=f44d3814&scoped=true"
import script from "./CoreAdvantages.vue?vue&type=script&lang=js"
export * from "./CoreAdvantages.vue?vue&type=script&lang=js"
import style0 from "./CoreAdvantages.vue?vue&type=style&index=0&id=f44d3814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d3814",
  null
  
)

export default component.exports